var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Liderzy---Video",
    transform: "translate(-440.000000, -203.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(410.000000, 187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(30.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,0.5 C11.9812609,0.5 14.2311363,1.50958001 15.8607781,3.13922187 C17.49042,4.76886373 18.5,7.01873913 18.5,9.5 C18.5,11.9812609 17.49042,14.2311363 15.8607781,15.8607781 C14.2311363,17.49042 11.9812609,18.5 9.5,18.5 C7.01873913,18.5 4.76886373,17.49042 3.13922187,15.8607781 C1.50958001,14.2311363 0.5,11.9812609 0.5,9.5 C0.5,7.01873913 1.50958001,4.76886373 3.13922187,3.13922187 C4.76886373,1.50958001 7.01873913,0.5 9.5,0.5 Z",
    id: "Shape",
    stroke: "#024766"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-10",
    fill: "#024766",
    points: "13 9.30305957 8 6 8 13"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo2);
export default __webpack_public_path__ + "static/media/video2.3b9c3ae0e0a2af4d98405d61aa0fa14f.svg";
export { ForwardRef as ReactComponent };